import { Select, FormControl, InputLabel, MenuItem, Typography } from "./MyCustomFile"
export const MySelectWithoutSearch = ({ label, value, onChange, options, error, helperText, disabled }) => {

    return (<>
        <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">{label}</InputLabel>
            <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={value}
                label={label}
                disabled={disabled || false}
                onChange={onChange}
            >
                {Array.isArray(options) && options.map((ele, i) => <MenuItem key={i} value={ele.value}>{ele.label}</MenuItem>)}
            </Select>
        </FormControl>
        {error && (<Typography variant="body2" style={{ color: "red", fontSize: "10px", marginLeft: "0" }}>{helperText}</Typography>)}
    </>);
}